module.exports = __webpack_public_path__ + "img/figure-ico.168ba3a2.svg";